import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchConfigurationItem(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedConfigurationItem";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.ConfigurationItemTypeName = ko.observable();
    self.ConfigurationItemTypeId = ko.observable();
    self.ConfigurationItemTypeId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.ConfigurationItemStatusName = ko.observable();
    self.ConfigurationItemStatusId = ko.observable();
    self.ConfigurationItemStatusId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.BuildingName = ko.observable();
    self.BuildingId = ko.observable();
    self.BuildingId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.LabelName = ko.observable();
    self.LabelId = ko.observable();
    self.LabelId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.NoParentConfigurationItem = ko.observable(false);
    self.NoParentConfigurationItem.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        if (self.ConfigurationItemTypeId() == null && self.ConfigurationItemStatusId() == null && self.BuildingId() == null && self.LabelId() == null
            && (self.NoParentConfigurationItem() == null || !self.NoParentConfigurationItem())) {
            return null;
        }
        else {
            return {
                ConfigurationItemTypeIds: self.ConfigurationItemTypeId() ? JSON.stringify(self.ConfigurationItemTypeId()) : null,
                ConfigurationItemStatusId: self.ConfigurationItemStatusId() ? JSON.stringify(self.ConfigurationItemStatusId()) : null,
                LabelId: self.LabelId() ? JSON.stringify(self.LabelId()) : null,
                BuildingId: self.BuildingId() ? JSON.stringify(self.BuildingId()) : null,
                NoParentConfigurationItem: self.NoParentConfigurationItem() ? JSON.stringify(self.NoParentConfigurationItem()) : null
            };
        }
    };
    self.init = function () {
        return self.LoadHtml();
    };
}
export default ExpandedSearchConfigurationItem;